import { CatalogueApiVersion } from "api/catalog/catalogApi";
import { useLifeCyclesAll } from "api/catalog/queries/useLifeCycles";
import { SelectOption } from "appkit-react";
import Select from "components/Select";
import sortBy from "lodash/sortBy";
import { useMemo } from "react";

interface ILifeCycleSelectProps {
  tenant: string;
  value: string[];
  onValueChange: (value: string[]) => void;
  hasError?: boolean;
  errMsg?: any;
  placeholder?: string;
  apiVersion?: CatalogueApiVersion;
  bothApiVersions?: boolean;
}

const LifeCycleSelect = ({
  tenant,
  value,
  onValueChange,
  apiVersion,
  bothApiVersions,
  ...selectProps
}: ILifeCycleSelectProps) => {
  const { data: lifecyclesAll = {} } = useLifeCyclesAll(undefined, 1);
  const { data: lifecyclesAllV2 = {} } = useLifeCyclesAll(undefined, 2);

  const lifecycles = useMemo(
    () =>
      sortBy(
        bothApiVersions
          ? [...(lifecyclesAll?.[tenant] || []), ...(lifecyclesAllV2?.[tenant] || [])]
          : apiVersion === 2
          ? lifecyclesAllV2?.[tenant] || []
          : lifecyclesAll?.[tenant] || [],
        (item) => item.order || item.name
      ),
    [apiVersion, bothApiVersions, lifecyclesAll, lifecyclesAllV2, tenant]
  );

  return (
    <Select
      multiple
      placeholder="Select a Life cycle"
      showSearchOnToggle
      value={value}
      onSelect={onValueChange}
      {...selectProps}
    >
      {lifecycles?.map((lifecycle) => (
        <SelectOption value={lifecycle.id} key={lifecycle.id}>
          {lifecycle.name}
        </SelectOption>
      ))}
    </Select>
  );
};

export default LifeCycleSelect;
